export enum FontVariantNumber {
  Thin = 100,
  ExtraLight = 200,
  Light = 300,
  Regular = 400,
  Medium = 500,
  SemiBold = 600,
  Bold = 700,
  ExtraBold = 800,
  Black = 900,
}

export enum FontVariantName {
  Thin = "Thin",
  ExtraLight = "Extra Light",
  Light = "Light",
  Regular = "Regular",
  Medium = "Medium",
  SemiBold = "Semi Bold",
  Bold = "Bold",
  ExtraBold = "Extra Bold",
  Black = "Black",
}

export const FontWeightNumberToName: Record<
  FontVariantNumber,
  FontVariantName
> = {
  [FontVariantNumber.Thin]: FontVariantName.Thin,
  [FontVariantNumber.ExtraLight]: FontVariantName.ExtraLight,
  [FontVariantNumber.Light]: FontVariantName.Light,
  [FontVariantNumber.Regular]: FontVariantName.Regular,
  [FontVariantNumber.Medium]: FontVariantName.Medium,
  [FontVariantNumber.SemiBold]: FontVariantName.SemiBold,
  [FontVariantNumber.Bold]: FontVariantName.Bold,
  [FontVariantNumber.ExtraBold]: FontVariantName.ExtraBold,
  [FontVariantNumber.Black]: FontVariantName.Black,
};

export const FontVariantNameToNumber: Record<
  FontVariantName,
  FontVariantNumber
> = {
  [FontVariantName.Thin]: FontVariantNumber.Thin,
  [FontVariantName.ExtraLight]: FontVariantNumber.ExtraLight,
  [FontVariantName.Light]: FontVariantNumber.Light,
  [FontVariantName.Regular]: FontVariantNumber.Regular,
  [FontVariantName.Medium]: FontVariantNumber.Medium,
  [FontVariantName.SemiBold]: FontVariantNumber.SemiBold,
  [FontVariantName.Bold]: FontVariantNumber.Bold,
  [FontVariantName.ExtraBold]: FontVariantNumber.ExtraBold,
  [FontVariantName.Black]: FontVariantNumber.Black,
};

export interface FontVariant {
  family: string;
  url?: string;
}

export interface FontFamily {
  name: string;
  variants: FontVariant[];
}
